<template>
  <div class="form-group p-r-8" align="left">
    <div class="form-row">
      <div class="form-input cm-select-parent" :class="classes">
        <select
          class="form-control"
          id="expireYear"
          name="expireYear"
          :value="value"
          data-test="expire-year-select"
          @input="$emit('input', $event.target.value)"
          @change="$emit('input', $event.target.value)"
        >
          <option value="YYYY" disabled selected hidden>
            {{ $t("paymentdetails.cards.YYYY") }}
          </option>
          <option :key="year" v-for="year in years" :value="year | formatYear">
            {{ year }}
          </option>
        </select>
        <label for="expireYear" data-test="expire-year-label">{{
          $t("paymentdetails.cards.labelExpirationyear")
        }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "expirationYear",
  props: ["value", "messages", "flags"],
  data() {
    return {
      years: [],
    };
  },
  beforeMount() {
    let yearStart = new Date().getFullYear(),
      yearEnd = yearStart + 20;

    this.years = Array(yearEnd - yearStart + 1)
      .fill()
      .map(() => yearStart++);
  },
  computed: {
    classes() {
      if (this.flags.validated && !this.flags.valid) {
        return "error";
      }
      if (this.flags.validated && this.flags.valid) {
        return "success";
      }
      return "";
    },
  },
};
</script>
